import { put, call } from "redux-saga/effects";
import { renderErrorMessage } from "utils/render-error-message";
import { ApiResponse } from "./api/types";
import { turnMessageOn } from "./app/actions";
import { MessageData } from "./app/types";
import { logoutRequest } from "./auth/actions";
import { checkResponse } from "./utils";
import { MessageStates } from "containers/MessageBox";

export function* handleApiCall<T extends (...args: any[]) => any>(
  apiFunc: T,
  args: Parameters<T>,
  onSuccess?: (response: ApiResponse) => any
) {
  try {
    const response: ApiResponse = yield call(apiFunc, ...args);

    const err = checkResponse(response?.responseMessage);
    if (err) throw err;

    if (onSuccess) {
      yield call(onSuccess, response);
    }
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
  }
}

export function* showMessage(title: string, description: string) {
  const message: MessageData = {
    title: title,
    description: description,
    type: MessageStates.SUCCESS,
  };
  yield put(turnMessageOn(message));
}